module.exports = __webpack_public_path__ + "assets/img/thumb-AstonRX-Landing-Page.d036e7f5.jpg";